// extracted by mini-css-extract-plugin
module.exports = {"imageCredit":"imageCredit___2Hq7P"};